<template>
  <!-- 遮罩 -->
  <div class="el-loading-parent--relative">
    <div v-loading.fullscreen.lock="fullscreenLoading"></div>
  </div>
</template>

<script>
export default {
  name: 'publicMask',
  props: ['fullscreenLoading'],
  data () {
    return {}
  },
  mounted () {},
  methods: {
    init () {}
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/public/publicMask.vue